import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { ItemContainer, MenuItemWrapper, SubitemsList } from "./styles";
import { IconChevronDown } from "../../icons";
import { AnimatePresence } from "framer-motion";
import { MenuModal } from "../MenuModal";
import { MenuSubitem } from "../MenuSubitem";
export var MenuItem = function (_a) {
    var _b, _c;
    var item = _a.item, sideBarOpen = _a.sideBarOpen, categoryOpen = _a.categoryOpen, toggleCategoryOpen = _a.toggleCategoryOpen;
    var location = window.location.pathname.split("/")[1];
    var _d = useState(false), modalOpen = _d[0], setModalOpen = _d[1];
    var hasSubitems = item.subitems && item.subitems.length > 0;
    var pathToGo = item.function || hasSubitems || !item.path ? "#" : item.path;
    return (_jsxs(MenuItemWrapper, { onMouseLeave: function () {
            if (!sideBarOpen) {
                setModalOpen(false);
            }
        }, children: [_jsxs(ItemContainer, { id: "menu-item".concat(item.path), "$sideBarOpen": sideBarOpen, "$categoryOpen": categoryOpen === item.text, to: pathToGo, "aria-selected": location === ((_b = item.path) === null || _b === void 0 ? void 0 : _b.split("/")[1]), onMouseEnter: function () {
                    if (!sideBarOpen && hasSubitems) {
                        setModalOpen(true);
                    }
                }, onClick: function (e) {
                    e.stopPropagation();
                    if (sideBarOpen && hasSubitems) {
                        toggleCategoryOpen(item.text);
                    }
                    if (item.function) {
                        item.function();
                    }
                }, children: [item.icon, _jsx("span", { children: item.text }), sideBarOpen && hasSubitems && _jsx(IconChevronDown, { className: "chevron" })] }), _jsx(AnimatePresence, { initial: false, children: sideBarOpen && categoryOpen === item.text && (_jsx(SubitemsList, { initial: { height: 0 }, animate: { height: "auto" }, exit: { height: 0 }, transition: { duration: 0.3 }, children: (_c = item.subitems) === null || _c === void 0 ? void 0 : _c.map(function (subitem) { return (_jsx(MenuSubitem, { subitem: subitem, style: { marginLeft: 32 }, parentPath: item.path }, "menu-subitem".concat(item.path).concat(subitem.path))); }) })) }), modalOpen && _jsx(MenuModal, { item: item })] }));
};
//# sourceMappingURL=index.js.map